import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/shareIcons/list_dash.svg'


const _hoisted_1 = { class: "col gap-15 height-scroll pright-20" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "row pad-s" }
const _hoisted_4 = { class: "col gap-04 w-full pad-s" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = { class: "row pad-s" }
const _hoisted_7 = { class: "col gap-04 w-full pad-s" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col gap-10" }

import resultPreferences from './resultPreferences.vue'
import combinedReference from '../../combinedReference/combinedReference.vue'

import { ref, computed } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useAppUserStore } from '@/stores/appUser'
import { LATERALITY_KEYS_FULL, createResultSuggestionsFromText } from "@/functions/resultSuggestion.js"
import { useUiStore } from '@/stores/ui'
import editAppUserPreferences from '@/views/patientMain/editAppUserPreferences.vue'
import patientapi from "@/api/patientapi"
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'resultSuggestionsLower',
  setup(__props) {

const { t } = useI18n();
const uiStore = useUiStore()
const currentEntryStore = useCurrentEntryStore()
const appUserStore = useAppUserStore()

const dropd = ref(null)

function setRefSheet(resultExpr, refTab) {
  uiStore.setReferenceTab(refTab)               //refTab = Presentation, Etio, Complic
  uiStore.setCurrRefSheet(resultExpr.refSheet)  //refSheet = Object (e.g.Diabète refSheet)
}

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
})


const resultExpr = computed(() => {
  const resultExpressions = currentEntryStore.currCclSuggestionsFromResults?.expressions
  if (!resultExpressions) return null;
  const allRefSheets = resultExpressions.filter(expression => expression.refSheet)
  if (!allRefSheets) return null;
  const currResultExpr = allRefSheets.find(resultExpr => currentEntryStore.activeResultSuggestion === resultExpr.refSheet.appUserResultReferenceId)
  return currResultExpr
})

const allRefSheetSuggestions = computed(() => {
  if (!resultExpr.value) return []
  const refSheet = resultExpr.value.refSheet
  return [
    createRefSheetSuggestionObj("Presentation", refSheet.presentation0),
    createRefSheetSuggestionObj("Etio", refSheet.etio0),
    createRefSheetSuggestionObj("Complic", refSheet.complic0)
  ].filter(suggObj => suggObj !== null)
})

function createRefSheetSuggestionObj(key, refText) {
  if (refText === "") return null;
  const sctLanguage = appUserStore.currentAppUserData?.preferences?.sctLanguage;
  return {
    "key": key,
    "title": t(`refSheet.tabs.${key}`),
    "suggestions": createResultSuggestionsFromText(refText, sctLanguage),
  }
}

function addSuggestion(suggGroupKey, newEntryText, newEntryUnit) {
  currentEntryStore.setIsManualSet(true);
  if (isEditable.value) {
    if (LATERALITY_KEYS_FULL.includes(suggGroupKey)) {
        const suggestionTerm = t(`patient.suggestion.sign.${suggGroupKey}`, suggGroupKey); 
        newEntryText = suggestionTerm + ": " + newEntryText.charAt(0).toLowerCase() + newEntryText.slice(1)
      }
      currentEntryStore.setNewEntryText(newEntryText)
      currentEntryStore.setNewEntryUnit(newEntryUnit)
  }
}

function getSoloKey(key) {
  return (LATERALITY_KEYS_FULL.includes(key)) ? key.slice(0, -1) : key
}

function getSoloTerm(key) {
  const term = t(`patient.suggestion.sign.${key}`, key)
  return (LATERALITY_KEYS_FULL.includes(key))  ? term.slice(0, -2) : term
}

async function addGroupForTitleSuggestion(newGroupTitle: string) {
  if (!currentEntryStore.hasCurrentEntry) return;
  const entryId = currentEntryStore.currentEntryId;
  //Backend
  const newCcl = await patientapi.addAssessmentCclFromTitleSuggestion(entryId, newGroupTitle)
  await currentEntryStore.reloadAfterHistoryChange();
  currentEntryStore.setConclusionIdToFocusOnExpr(newCcl.conclusionGroupId)
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_itemModal = _resolveComponent("itemModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentEntryStore).activeResultSuggestion === 'GroupSuggestions')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.suggestion.sign.Groups'),
              class: "pad-m pleft-015 font-size-16 font-bold-700"
            }, null, 8, ["txt"]),
            _createVNode(_component_dropdownBox, {
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
              openOn: "GroupSuggestions",
              combo: true
            }, {
              dropd: _withCtx(() => [
                _createVNode(editAppUserPreferences, {
                  title: "Favoris",
                  referenceTextType: "ResultTitles",
                  dtoKey: "resultTitles"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_es_button_icon, {
                  icon: "gear",
                  folder: "menuIcons",
                  styles: "img-grey h-16 w-16"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appUserStore).currentAppUserData?.preferences?.resultTitles?.split('\n'), (suggestion, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                suggestion
                  ? (_openBlock(), _createBlock(_component_button_group, {
                      key: 0,
                      styles: "pad-s",
                      class: "psides-05 align-center",
                      onClick: ($event: any) => (addGroupForTitleSuggestion(suggestion))
                    }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                        _createVNode(_component_text_item, {
                          txt: suggestion,
                          styles: "font-mBold",
                          class: "mleft-04"
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(appUserStore).cachedResultSuggestions)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(appUserStore).cachedResultSuggestions, (suggGroupValue, suggGroupKey, suggGroupIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: suggGroupIndex }, [
            (_unref(currentEntryStore).activeResultSuggestion === suggGroupKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_text_item, {
                      txt: _unref(t)(`patient.suggestion.sign.${suggGroupKey}`, suggGroupKey),
                      class: "pad-m pleft-015 font-size-16 font-bold-700"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_dropdownBox, {
                      modelValue: dropd.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                      openOn: 'ResultSuggestionPreference' + suggGroupKey,
                      combo: true
                    }, {
                      dropd: _withCtx(() => [
                        _createVNode(resultPreferences, {
                          resultKey: getSoloKey(suggGroupKey),
                          groupTerm: getSoloTerm(suggGroupKey)
                        }, null, 8, ["resultKey", "groupTerm"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_es_button_icon, {
                          icon: "gear",
                          folder: "menuIcons",
                          styles: "img-grey h-16 w-16"
                        })
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "openOn"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggGroupValue, (group, groupIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: groupIndex,
                        class: _normalizeClass(["w-full", {'es-suggestions' : groupIndex > 0}])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (suggValue, suggKey, suggIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: suggIndex,
                            class: "w-full row gap-02"
                          }, [
                            (suggValue.neg)
                              ? (_openBlock(), _createBlock(_component_es_button_icon, {
                                  key: 0,
                                  disabled: !isEditable.value,
                                  icon: "empty-set",
                                  folder: "shareIcons",
                                  styles: "h-12 w-12",
                                  onClick: _withModifiers(($event: any) => (addSuggestion(suggGroupKey, suggValue.neg, '')), ["stop"])
                                }, null, 8, ["disabled", "onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_text_item, {
                              txt: suggValue.entry,
                              class: _normalizeClass([{'es-suggestion-txt': isEditable.value}, "main-h pad-s"]),
                              onClick: ($event: any) => (addSuggestion(suggGroupKey, suggValue.entry, suggValue.unit))
                            }, null, 8, ["txt", "class", "onClick"])
                          ]))
                        }), 128))
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allRefSheetSuggestions.value, (suggGroupValue, suggGroupIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: suggGroupIndex,
        class: "pad-m"
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_text_item, {
            txt: suggGroupValue.title,
            styles: "font-mBold",
            class: "pad-m",
            style: {"padding-left":"0.15rem"}
          }, null, 8, ["txt"]),
          _createVNode(_component_itemModal, {
            center: true,
            uiId: "referenceFromResultSugg"
          }, {
            modal: _withCtx(() => [
              _createVNode(combinedReference)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_es_button_icon, {
                icon: "gear",
                folder: "menuIcons",
                styles: "img-grey h-16 w-16",
                onClick: ($event: any) => (setRefSheet(resultExpr.value, suggGroupValue.key))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggGroupValue.suggestions, (group, groupIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: groupIndex,
              class: "w-full"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (suggValue, suggKey, suggIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: suggIndex,
                  class: "w-full row gap-02"
                }, [
                  (suggValue.neg)
                    ? (_openBlock(), _createBlock(_component_es_button_icon, {
                        key: 0,
                        disabled: !isEditable.value,
                        icon: "empty-set",
                        folder: "shareIcons",
                        styles: "h-12 w-12",
                        onClick: _withModifiers(($event: any) => (addSuggestion(_ctx.suggGroupKey, suggValue.neg, '')), ["stop"])
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_text_item, {
                    txt: suggValue.entry,
                    class: _normalizeClass([{'es-suggestion-txt': isEditable.value}, "main-h pad-s"]),
                    onClick: ($event: any) => (addSuggestion(_ctx.suggGroupKey, suggValue.entry, suggValue.unit))
                  }, null, 8, ["txt", "class", "onClick"])
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})